export default __webpack_public_path__ + "c9931e67d537f4351addc2a7388eedff.png";